import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {DestinationUpdate} from './interfaces/destination.model';
import {Destination, DestinationRequest} from './destination.model';
import {UUID} from '../../../shared/types/uuid.type';

@Injectable({
  providedIn: 'root'
})
export class DestinationsService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getDestinations(): Observable<Destination[]> {
    return this.apiService.get(`/destinations`);
  }

  public getDestination(destinationId: UUID): Observable<Destination> {
    return this.apiService.get(`/destinations/${destinationId}`);
  }

  public create(data: DestinationRequest): Observable<Destination> {
    return this.apiService.post(`/destinations`, data);
  }

  public update(update: DestinationUpdate): Observable<Destination> {
    const id: string = update.id;
    const data: DestinationRequest = update.data;
    return this.apiService.put(`/destinations/${id}`, data);
  }

  public delete(destinationId: UUID): Observable<Destination> {
    return this.apiService.delete(`/destinations/${destinationId}`);
  }

  public startDestination(destinationId: UUID): Observable<Destination> {
    return this.apiService.get(`/destinations/resume/${destinationId}`);
  }

  public stopDestination(destinationId: UUID): Observable<Destination> {
    return this.apiService.get(`/destinations/stop/${destinationId}`);
  }
}
